// extracted by mini-css-extract-plugin
export default {"grey":"StuPicker_grey__jcEU5","blue":"StuPicker_blue__A3p9e"};